import type { VideoDetail, VideoListItem, Question } from "../api/content";

const DEMO_ID_PREFIX = "demo-";
const DEMO_SESSION_ID_PREFIX = "demo-session-";

export const isDemoVideoId = (id: string): boolean =>
  id.startsWith(DEMO_ID_PREFIX);

export const isDemoSessionId = (id: string): boolean =>
  id.startsWith(DEMO_SESSION_ID_PREFIX);

export const makeDemoSessionId = (videoId: string): string =>
  `${DEMO_SESSION_ID_PREFIX}${videoId}-${Date.now()}`;

const mkQuestion = (
  videoId: string,
  suffix: string,
  tSec: number,
  prompt: string,
  options: string[],
  correct: number,
): Question => ({
  id: `${videoId}-q-${suffix}`,
  videoId,
  tSec,
  prompt,
  options,
  correct,
});

export const DEMO_VIDEOS: VideoDetail[] = [
  {
    id: `${DEMO_ID_PREFIX}apples`,
    title: "Count the Apples",
    thumbUrl: "https://picsum.photos/seed/apples/640/360",
    duration: 300,
    ageMin: 2,
    ageMax: 5,
    categories: ["numbers"],
    isPremium: false,
    hlsUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    questions: [
      mkQuestion(
        `${DEMO_ID_PREFIX}apples`,
        "1",
        30,
        "How many apples do you see?",
        ["one", "two", "three", "four"],
        2,
      ),
    ],
  },
  {
    id: `${DEMO_ID_PREFIX}colors`,
    title: "Learn Colors with Friends",
    thumbUrl: "https://picsum.photos/seed/colors/640/360",
    duration: 240,
    ageMin: 2,
    ageMax: 6,
    categories: ["colors"],
    isPremium: false,
    hlsUrl:
      "https://devstreaming-cdn.apple.com/videos/streaming/examples/bipbop_16x9/bipbop_16x9_variant.m3u8",
    questions: [
      mkQuestion(
        `${DEMO_ID_PREFIX}colors`,
        "1",
        20,
        "Which one is red?",
        ["red", "blue", "green", "yellow"],
        0,
      ),
    ],
  },
  {
    id: `${DEMO_ID_PREFIX}abcs`,
    title: "ABCs with Grandma",
    thumbUrl: "https://picsum.photos/seed/abcs/640/360",
    duration: 360,
    ageMin: 3,
    ageMax: 6,
    categories: ["letters"],
    isPremium: false,
    hlsUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    questions: [
      mkQuestion(
        `${DEMO_ID_PREFIX}abcs`,
        "1",
        25,
        "Pick the letter A",
        ["a", "b", "c", "d"],
        0,
      ),
    ],
  },
  {
    id: `${DEMO_ID_PREFIX}bedtime`,
    title: "Bedtime Calm Story",
    thumbUrl: "https://picsum.photos/seed/bedtime/640/360",
    duration: 480,
    ageMin: 2,
    ageMax: 8,
    categories: ["bedtime"],
    isPremium: false,
    hlsUrl:
      "https://devstreaming-cdn.apple.com/videos/streaming/examples/bipbop_16x9/bipbop_16x9_variant.m3u8",
    questions: [],
  },
  {
    id: `${DEMO_ID_PREFIX}shapes`,
    title: "Shapes All Around",
    thumbUrl: "https://picsum.photos/seed/shapes/640/360",
    duration: 300,
    ageMin: 3,
    ageMax: 7,
    categories: ["shapes"],
    isPremium: false,
    hlsUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
    questions: [
      mkQuestion(
        `${DEMO_ID_PREFIX}shapes`,
        "1",
        30,
        "What is this shape?",
        ["circle", "square", "triangle", "star"],
        0,
      ),
    ],
  },
];

export const DEMO_VIDEO_LIST_ITEMS: VideoListItem[] = DEMO_VIDEOS.map((v) => ({
  id: v.id,
  title: v.title,
  thumbUrl: v.thumbUrl,
  duration: v.duration,
  ageMin: v.ageMin,
  ageMax: v.ageMax,
  categories: v.categories,
  isPremium: v.isPremium,
}));

export const getDemoVideo = (id: string): VideoDetail | undefined =>
  DEMO_VIDEOS.find((v) => v.id === id);
